// extracted by mini-css-extract-plugin
export var active = "_gb-7";
export var blink = "_gb-8";
export var dropDownSelector = "_gb-4";
export var dropDownWrapper = "_gb-3";
export var fakeCursor = "_gb-6";
export var fontSizeButton = "_gb-9";
export var formQuillEditor = "_gb-0";
export var pressed = "_gb-a";
export var qlBlank = "_gb-1";
export var textFormattingToolbar = "_gb-2";
export var textToolbarOption = "_gb-5";